import { atomWithReset } from "jotai/utils";
import type { DtfArtworkPricing } from "@design-lab/entities/transfers-lab/api";

// Type for pricing key (without hyphens to match backend)
type PricingKey = string; // artworkIdtransferTypeIdsizeId

// Atom to store all pricing data
// Key format: "artworkIdtransferTypeIdsizeId" (no hyphens) -> DtfArtworkPricing
export const transferPricingAtom = atomWithReset<Record<PricingKey, DtfArtworkPricing>>({});

// Atom to track loading states for pricing
export const pricingLoadingAtom = atomWithReset<Record<PricingKey, boolean>>({});

// Helper function to create a pricing key
// Uses format without hyphens to match backend expectations
export const createPricingKey = (
  artworkId: string,
  transferTypeId: string,
  sizeId: string
): PricingKey => `${artworkId}${transferTypeId}${sizeId}`.replace(/-/g, "");
